import * as React from 'react';

const TrueConditionWidget= ({props})=> {

    return <div></div>
}

export default TrueConditionWidget;
